import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListSiteRecebimentoDTO, DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { CardBarCodeComponent } from 'src/app/shared/card-barcode/card-barcode.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua007-card-I',
    templateUrl: './qua007-card-I.component.html'
})

export class Qua007CardIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public filteredOptionsSiteRecebimento: Observable<DropDownListSiteRecebimentoDTO[]>;
    public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listSiteRecebimentoOriginal?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listTiposColheita?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTiposColheitaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredTiposColheitaOptions: Observable<DropDownListDTO[]>;
    public disableBtnCerar: boolean;
    public disableBtnOrdem: boolean;
    public disableBtnContrato: boolean;
    public disableCerar: boolean;
    public disableNumeroCampo: boolean = false;
    public safraBasicaOld = ''
    @Output() objPc003 = new EventEmitter();
    @Output() objHumidity = new EventEmitter();
    //@Output() objGeracao = new EventEmitter();
    @Output() objTrigger = new EventEmitter();
    @Output() mkCalcPreBasica = new EventEmitter();
    @Output() objPc003PreBasica = new EventEmitter();
    @Output() mkHarvestWeek = new EventEmitter();

    public readyOnlyGleba?: boolean;

    public listSafra?: DropDownListDTO[];
    public listSafraOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTransportadora?: DropDownListDTO[];
    public listTransportadoraOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listResponsavel?: DropDownListDTO[];
    public listResponsavelOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public isSafraBasica = false;
    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
        super('Etapa 1', false);

        if (this.isComercial || this.isBasica) {

            this.formulario = this.formBuilder.group({
                Safra: [null, [Validators.pattern(this.regexSafra)]],
                Site_recebimento: [null, [Validators.required]],
                Cerar: [null, [Validators.required, Validators.pattern(this.regexCerar)]],
                Ordem_Rw: [null, [Validators.required]],
                Contrato_Juridico: [null, [Validators.required]],
                Gleba: [null, [Validators.max(9)]],
                Site_origem: [null, []],
                Cooperante: [null, []],
                Hibrido: [null, []],
                Especie: [null, []],
                Tp_colheita: [null, []],
                Geracao: [null, []],
                Nr_campo: [null, []],
            })
        }
        else {
            this.step = 'Dados do Campo:'
            this.formulario = this.formBuilder.group({
                Safra: [null, []],
                Safra_basica: [null, [Validators.pattern(this.regexSafraBasica), Validators.required]],
                Site_recebimento: [null, [Validators.required]],
                Cerar: [null, []],
                Cerar_basica: [null, [Validators.required]],
                Contrato_Juridico: [null, [Validators.required]],
                Gleba: [null, []],
                Site_origem: [null, []],
                Cooperante: [null, [Validators.required]],
                hibrido_rnc: [null, [Validators.required]],
                Especie: ['Milho', [Validators.required]],
                Tp_colheita: ['Manual', [Validators.required]],
                Geracao: [null, [Validators.required]],
                Nr_campo: [null, [Validators.required]],

                // parte II card

                Umidade: [null, []],
                Dt_colheita: [null, [Validators.pattern(this.regexDate), Validators.required]],
                Termino_enchimento_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate), Validators.required]],
                Termino_enchimento_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],
                Saida_campo_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate), Validators.required]],
                Saida_campo_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],
                Tempo_espera_campo: [null, [Validators.required]],
                Resp_liberacao_colheita: [null, [Validators.required]],
                controle_secagem: [null, []],

                // parte III card

                Placa_carreta: [null, [Validators.pattern('\[A-Z a-z]{3}[0-9][0-9A-Z a-z][0-9]{2}'), Validators.required]],
                Transportadora: [null, [Validators.required]],
                Nfp_nota_fiscal: [null, []],

                Lote_rw: [null, [Validators.pattern(this.regexLoteRwPet), Validators.required]],
                nota_ardida: [null, [Validators.required]],
            });
            this.readyOnlyGleba = true;
            this.isSafraBasica = true
        }

    }

    async ngOnInit(): Promise<void> {
        this.readyOnlyGleba = false;
        this.formulario.get('Cerar').setErrors({ invalidCerar: false });
        await this.checkBtnLeitorEnable()
        await this.getLists();

    }
    async getLists() {
        await Promise.all([this.getListSiteRecebimento(), this.getListTiposColheita(), this.getListSafra()]);
        if (this.isPreBasica) {
            await this.getListTransportadora();
            await this.getListResponsavel();
        }
    }

    async makeCalculationsPreBasica(): Promise<void> {
        this.mkCalcPreBasica.emit();
    }

    async getListSafra(): Promise<void> {
        await this.formularioService
            .getListDropDownList('qua007', 'safra')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listSafra = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listSafraOriginal = this.listSafra;
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    async createFilterSafra(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (
                this.listSafraOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                ).length > 0
            ) {
                this.listSafra = this.listSafraOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                );
            } else {
                this.listSafra = this.listSafraOriginal;
            }
        } else {
            this.listSafra = this.listSafraOriginal;
        }
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getDataPc003(): Promise<void> {
        this.objPc003.emit();
    }
    async getDataPc003PreBasica(): Promise<void> {
        this.objPc003PreBasica.emit();
    }

    async getHumidityData(): Promise<void> {
        const cerar = this.formulario.get('Cerar')?.value as string;
        if (!!cerar && cerar?.length > 0) {
            await this.formularioService.getHumidityData(cerar).pipe(take(1)).toPromise().then((response: any) => {
                this.objHumidity.emit(response?.data);
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar a umidade para o cerar ${cerar}. Entre em contato com o Administrador.`);
            });
        }
    }

    async getListSiteRecebimento(): Promise<void> {
        this.listSiteRecebimento = this.generalService.getListSiteRecebimento();
        this.listSiteRecebimentoOriginal = this.listSiteRecebimento;
    }

    async getListTiposColheita(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'tipo_colheita').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listTiposColheita = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listTiposColheitaOriginal = this.listTiposColheita;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    createFilterTiposColheita(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listTiposColheitaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTiposColheita = this.listTiposColheitaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTiposColheita = this.listTiposColheitaOriginal;
            }
        } else {
            this.listTiposColheita = this.listTiposColheitaOriginal;
        }
    }

    createFilterSiteRecebimento(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listSiteRecebimentoOriginal.filter(x => x.initials?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSiteRecebimento = this.listSiteRecebimentoOriginal.filter(x => x.initials?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSiteRecebimento = this.listSiteRecebimentoOriginal;
            }
        } else {
            this.listSiteRecebimento = this.listSiteRecebimentoOriginal;
        }
        // this.filteredOptionsSiteRecebimento = this.formulario.get('Site_recebimento').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownListSiteRecebimento(this.listSiteRecebimento, value))
        //     );
    }

    async openDialog(typeField: string): Promise<void> {
        await this.checkBtnLeitorDisable();
        const dialogRef = this.dialog.open(CardBarCodeComponent, {
            width: '670px',
            height: '700px',
            data: {
                field: typeField,
            },
        });
        dialogRef.afterClosed().subscribe(async data => {
            await this.checkBtnLeitorEnable();
            await this.resultAfterBarCode(typeField, data);
        });
    }

    async resultAfterBarCode(field: string, barCode: string) {
        switch (field) {
            case 'Cerar':
                this.formulario.get('Cerar').setValue(barCode);
                await this.checkCerarExist();
                break;
            case 'Ordem':
                this.formulario.get('Ordem_Rw').setValue(barCode);
                break;
            case 'Contrato':
                this.formulario.get('Contrato_Juridico').setValue(barCode);
                await this.getDataPc003();
                break;
        }
    }

    async checkBtnLeitorDisable(): Promise<void> {
        this.disableBtnCerar = true;
        this.disableBtnOrdem = true;
        this.disableBtnContrato = true;
    }

    async checkBtnLeitorEnable(): Promise<void> {
        this.disableBtnCerar = false;
        this.disableBtnOrdem = false;
        this.disableBtnContrato = false;
    }

    async checkCerarExist(): Promise<void> {
        if (!this.disableCerar) {
            const cerar: string = this.formulario.get('Cerar')?.value;
            await this.formularioService.checkValueExists('cerar', 'qua007', cerar).pipe(take(1)).toPromise().then(async (response: any) => {
                if (!!response?.data) {
                    if ((response.data as boolean) === true) {
                        this.formulario.get('Cerar').setErrors({ invalidCerar: true });;
                        this.notificationService.sendNotification(`O Cerar ${cerar} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
                    } else {
                        this.formulario.get('Cerar').setErrors({ invalidCerar: false });
                        this.formulario.get('Cerar').updateValueAndValidity();
                        await this.getHumidityData();
                    }
                }
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar a umidade para o cerar ${cerar}. Entre em contato com o Administrador.`);
            });
        }
    }
    async checkCerarBasicaExist(): Promise<void> {
        if (!this.disableCerar) {
            const cerar: string = this.formulario.get('Cerar_basica')?.value;
            await this.formularioService.checkValueExists('cerar_basica', 'qua007', cerar).pipe(take(1)).toPromise().then(async (response: any) => {
                if (!!response?.data) {
                    if ((response.data as boolean) === true) {
                        this.formulario.get('Cerar_basica').setErrors({ invalidCerar: true });;
                        this.notificationService.sendNotification(`O Cerar ${cerar} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
                    } else {
                        this.formulario.get('Cerar_basica').setErrors({ invalidCerar: false });
                        this.formulario.get('Cerar_basica').updateValueAndValidity();
                        await this.getHumidityData();
                    }
                }
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar a umidade para o cerar ${cerar}. Entre em contato com o Administrador.`);
            });
        }
    }

    async triggerContractAndSite(): Promise<void> {
        //this.objGeracao.emit();
        this.objTrigger.emit();
    }


    createFilterTransportadora(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listTransportadoraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTransportadora = this.listTransportadoraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTransportadora = this.listTransportadoraOriginal;
            }
        } else {
            this.listTransportadora = this.listTransportadoraOriginal;
        }
        // this.filteredOptions = this.formulario.get('Transportadora').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listTransportadora, value))
        //     );
    }

    async getListTransportadora(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite();
        await this.formularioService.getListDropDownList('qua007', 'transportadora', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listTransportadora = this.generalService.orderByDropDownList(response.data as DropDownListDTO[], true);
                this.listTransportadoraOriginal = this.listTransportadora;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
    createFilterResponsavel(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listResponsavelOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listResponsavel = this.listResponsavelOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listResponsavel = this.listResponsavelOriginal;
            }
        } else {
            this.listResponsavel = this.listResponsavelOriginal;
        }
        // this.filteredOptions = this.formulario.get('Transportadora').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listResponsavel, value))
        //     );
    }

    async getListResponsavel(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite();
        await this.formularioService.getListDropDownList('qua007', 'responsavel_liberacao_colheita', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listResponsavel = this.generalService.orderByDropDownList(response.data as DropDownListDTO[], true);
                this.listResponsavelOriginal = this.listResponsavel;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async calcHarvestWeek(): Promise<void> {
        this.mkHarvestWeek.emit();
    }

    converterSafra() {
        const safraBasica = (this.formulario.get('Safra_basica')?.value as string)?.toUpperCase()
        const prefix = safraBasica.substring(0, 2); // Pega o prefixo (IN ou VE)
        const year = safraBasica.substring(3); // Pega o ano (22)
        if ((!safraBasica.includes('INV') && !safraBasica.includes('VER'))) {
            this.formulario.get('Safra_basica')?.setErrors({ pattern: false })
            this.formulario.get('Safra_basica').updateValueAndValidity()

            return
        }
        console.log(safraBasica)
        console.log(`${prefix}${year}`)
        this.formulario.get('Safra')?.setValue(`${prefix}${year}`)


        this.formulario.get('Safra_basica')?.setValue(safraBasica)

        this.formulario.get('Safra_basica')?.setErrors({ pattern: true })
        this.formulario.get('Safra_basica').updateValueAndValidity()
        // if (safraBasica != "" || safraBasica != null) {

        //     this.disableNumeroCampo = this.safraBasicaOld == safraBasica
        // }
        this.getDataPc003PreBasica();
        this.calcHarvestWeek();
    }
    async checkNumeroCampo() {
        const site = this.formulario.get('Site_recebimento')?.value
        const safra = this.formulario.get('Safra_basica')?.value
        const numeroCampo = this.formulario.get('Nr_campo')?.value
        if (!site || !safra || !numeroCampo || this.disableNumeroCampo) {
            return
        }
        this.formularioService.checkNumeroCampo('qua007', {
            filters: {
                numero_campo: numeroCampo as string,
                site_recebimento: site as string,
                safra_basica: safra as string
            }
        }).pipe(take(1)).toPromise().then((response: any) => {

            if ((response.data as boolean) === true) {
                this.formulario.get('Nr_campo').setErrors({ invalidExist: true });;
                this.notificationService.sendNotification(`O Numero do campo ${numeroCampo} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
            } else {
                this.formulario.get('Nr_campo').setErrors({ invalidExist: false });
                this.formulario.get('Nr_campo').updateValueAndValidity();
                this.getDataPc003PreBasica();
            }

        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
}


